import React from "react";
import Icon from "../components/Icon";
import Form from "../components/Form";
import Configuration, { translations } from "../config";
import ReactGA from "react-ga";
import { checkUserAndOrganization } from "../actions/Users";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { message } from "../actions";

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		checkUserAndOrganization: ( a_formData ) =>
		{
			return dispatch( checkUserAndOrganization( a_formData ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class UserFields extends React.Component
{
	
	constructor( props )
	{
		super( props );
		
		this.state = this.props.fieldValues.customer
			? { ...this.props.fieldValues.customer, password: "", password_2: "" }
			: {};
	}
	
	componentDidMount()
	{
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( translations.de_DE.routes.registration );
		}
		
	} // function componentDidMount()
	
	handleStep( event, formData )
	{
		event.preventDefault();
		
		// Prüfung auf doppelte E-Mail und Organisation
		this.props.checkUserAndOrganization( formData ).then(
			result =>
			{
				if ( result )
				{
					this.props.saveValues( formData, "customer" );
					this.props.nextStep();
				}
			}
		);
		
	} // function handleStep()
	
	render()
	{
		return <div className={"col s12"}>
			<h3>Persönliche Daten</h3>
			<p>Durch die Eingabe Ihrer Daten erhalten Sie einen persönlichen Zugang zur Ihren {translations.de_DE.words.appName}.<br/>
				Weitere Informationen zur Verwendung Ihrer Daten finden Sie in unserer <NavLink to={"/datenschutz"} target={"_blank"}>
					<strong>Datenschutzerklärung</strong></NavLink>.</p>
			<Form className="col s12"
			      id={`form-new-user_user_fields`}
			      submitValue={[ <Icon key={`form-new-user-icon`} iconName={"next"}/>, <span key={`form-new-user-text`}>nächster Schritt</span> ]}
			      onSubmit={( event, formData ) => this.handleStep( event, formData )}
			      fields={[
				      {
					      name: "sex",
					      title: "Anrede",
					      type: "select",
					      options: [
						      { value: "n", title: "keine Angabe" },
						      { value: "m", title: "Herr" },
						      { value: "f", title: "Frau" }
					      ],
					      required: true,
					      cleared: true,
					      className: "col s12 m4 xl2"
				      },
				      {
					      name: "forename",
					      title: "Vorname",
					      type: "text",
					      maxLength: "50",
					      required: true,
					      className: "col s12 m6 l4 xl3"
				      },
				      {
					      name: "surname",
					      title: "Nachname",
					      type: "text",
					      maxLength: "50",
					      required: true,
					      cleared: true,
					      className: "col s12 m6 l4 xl3"
				      },
				      {
					      name: "organization_name",
					      title: "Name",
					      type: "text",
					      maxLength: "80",
					      required: true,
					      className: "col s12 m6",
					      label: "Organisation"
				      },
				      {
					      name: "vat_id",
					      title: "Umsatzsteuer-IdNr.",
					      type: "text",
					      maxLength: "20",
					      required: true,
					      cleared: true,
					      className: "col s12 m6 offset-l2 l4",
					      validator: ( a_value ) =>
					      {
						      if ( !Configuration.vatRegex.test( a_value ) )
						      {
							      // Nur auf den Fehler hinweisen.
							      this.props.message( "Die USt-IdNr. ist unvollständig oder enthält ungültige Zeichen." );
						      }
						
						      return true;
					      }
				      },
				      {
					      name: "organization_street",
					      title: "Straße",
					      type: "text",
					      maxLength: "50",
					      required: true,
					      className: "col s12 m8 l4"
				      },
				      {
					      name: "organization_street_number",
					      title: "Hausnummer",
					      type: "text",
					      maxLength: "24",
					      required: true,
					      className: "col s12 m4 l2"
				      },
				      {
					      name: "phone_number",
					      title: "Telefonnummer",
					      type: "tel",
					      maxLength: "50",
					      cleared: true,
					      className: "col s12 m6 offset-l2 l4"
				      },
				      {
					      name: "organization_postal_code",
					      title: "Postleitzahl",
					      type: "text",
					      maxLength: "10",
					      required: true,
					      className: "col s12 m4 l2"
				      },
				      {
					      name: "organization_city",
					      title: "Ort",
					      type: "text",
					      maxLength: "50",
					      required: true,
					      cleared: true,
					      className: "col s12 m8 l4"
				      },
				      {
					      name: "email",
					      title: "E-Mail (Benutzername)",
					      type: "email",
					      maxLength: "80",
					      required: true,
					      className: "col s12 m6 l4",
					      label: "Zugangsdaten"
				      },
				      {
					      name: "password",
					      title: "Passwort",
					      type: "password",
					      maxLength: "80",
					      required: true,
					      className: "col s12 m6 cleared-m l4",
					      help: "Mindestens 7 Buchstaben und 1 Sonderzeichen (!@#$%^&\"'.,+*-)",
					      validator: ( a_value ) =>
					      {
						      if ( !Configuration.passwordRegex.test( a_value ) )
						      {
							      this.props.message( "Das Passwort muss mindestens 7 Buchstaben und 1 Sonderzeichen enthalten." );
							      return false;
						      }
						
						      return true;
					      }
				      },
				      {
					      name: "password_2",
					      title: "Passwort wiederholen",
					      type: "password",
					      maxLength: "80",
					      required: true,
					      cleared: true,
					      className: "col s12 m6 l4"
				      }
			      ]
			      }
			      errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
			      validator={
				      ( a_domElements ) =>
				      {
					      const pw1 = a_domElements[ "password" ].value;
					      const pw2 = a_domElements[ "password_2" ].value;
					      if ( pw1 !== pw2 )
					      {
						      this.props.message( "Die Passwörter stimmen nicht überein." );
						      return false;
					      }
					
					      return true;
				      }
			      }
			      values={this.state}
			/>
		</div>;
		
	} // function render()
	
} // class

UserFields = connect(
	null,
	mapDispatchToProps
)( UserFields );

export default UserFields;
